import serviceInfo from "./i18n-translate-420508-2f1b5c594681.json";
const STATUS = import.meta.env.VITE_STATUS;

export const isTest = STATUS === "TEST";
export const BASE_URL =
  STATUS === "PROD"
    ? import.meta.env.VITE_PROD_URL
    : import.meta.env.VITE_TEST_URL;

export interface ProductInfo {
  key: string;
  name: string;
}
export const ProductKeyList = [
  "WRAPSODY",
  "WRAPSODY_ECO",
  "MIND_SAT",
  "DSPM",
  "DSP",
  "FIRESIDE",
];
export type ProductKey =
  | "WRAPSODY"
  | "WRAPSODY_ECO"
  | "MIND_SAT"
  | "DSPM"
  | "DSP"
  | "FIRESIDE";

export interface IProductInfo {
  WRAPSODY: ProductInfo;
  WRAPSODY_ECO: ProductInfo;
  DSPM: ProductInfo;
  DSF: ProductInfo;
}
export const mindsatServiceNameMap = {
  VIDEO: "siteType.premium.mindsat.service.option.VIDEO",
  REPORT: "siteType.premium.mindsat.service.option.REPORT",
  CLIENT_CONTROL: "siteType.premium.mindsat.service.option.CLIENT_CONTROL",
  AI_SERVICE: "siteType.premium.mindsat.service.option.AI_SERVICE",
  QSHING: "siteType.premium.mindsat.service.option.QSHING",
};
// 패키지 제품 코드별 표시명 매핑 (매핑이 없으면 코드 그대로 노출)
export const packageProductDisplayNameMap: Record<string, string> = {
  FED: "FED-N",
};
// 제품 정보
export const productInfo: Record<ProductKey, ProductInfo> = {
  WRAPSODY: {
    key: "wrapsody",
    name: "Wrapsody Cloud",
  },
  WRAPSODY_ECO: {
    key: "eco",
    name: "Wrapsody eCo Cloud",
  },
  MIND_SAT: {
    key: "mind-sat",
    name: "mind-SAT",
  },
  DSPM: {
    key: "dspm",
    name: "DSPM",
  },
  DSP: {
    key: "dsp",
    name: "Fasoo DSP",
  },
  FIRESIDE: {
    key: "fireside",
    name: "Fireside",
  },
};

export const priceListKeyMap: Record<ProductKey, string> = {
  WRAPSODY: "wrapsody",
  WRAPSODY_ECO: "eco",
  MIND_SAT: "mind-sat",
  DSPM: "dspm",
  DSP: "dsp",
  FIRESIDE: "fireside",
};

declare global {
  interface Window {
    _env_: {
      REACT_APP_USE_MOCK_DATA?: string;
    };
  }
}
// 프로모션 결제 페이지
export const promotionPayPage = ["/pay/card"];

export const USE_MOCK_DATA = import.meta.env.VITE_USE_MOCK_DATA === "true";

// Google Sheet
export const GoogleServiceAccountEmail = serviceInfo.client_email;
export const GooglePrivateKey = serviceInfo.private_key;
export const GoogleSheetId: string = import.meta.env.VITE_GOOGLE_SHEET_ID ?? "";
export const GoogleSheetApiKey = import.meta.env.VITE_GOOGLE_SHEETS_API_KEY;
export const GoogleSheetTab = "common";

// 랩소디/에코 클라우드 도메인 (운영/테스트)
export const WRAPSODY_CLOUD_HOST = isTest
  ? "staging-cloud-a9k3f.wrapsody.com"
  : "cloud.wrapsody.com";
export const WRAPSODY_ECO_CLOUD_HOST = isTest
  ? "staging-cloud-f2b7x.wrapsodyeco.com"
  : "cloud.wrapsodyeco.com";
export const WRAPSODY_CLOUD_URL = `https://${WRAPSODY_CLOUD_HOST}`;
export const WRAPSODY_ECO_CLOUD_URL = `https://${WRAPSODY_ECO_CLOUD_HOST}`;
